export default {
    login: {
        t01: 'Sprache',
        t02: 'Netflix',
        t03: 'Bitte geben Sie Ihren Benutzernamen ein',
        t04: 'Bitte geben Sie Ihr Passwort ein',
        t05: 'Anmelden',
        t06: 'Registrieren',
        t07: 'Bitte geben Sie Ihre Telefonnummer ein',
        t08: 'Passwort bestätigen',
        t09: 'Bitte geben Sie den Einladungscode ein',
        t10: 'Konto registrieren',
        t11: 'Bitte bestätigen Sie Ihr Passwort',
        t13: 'Die Liebe zum Film kann dazu führen, dass du ganz unbemerkt ein beachtliches Vermögen anhäufst.',
        t14: 'Anmeldung erfolgreich',
        t15: 'Passwörter stimmen nicht überein',
        t16: 'Registrierung erfolgreich',
        t17: 'Netzwerkfehler',
        t18: 'Anforderungstimeout, bitte überprüfen Sie Ihre Netzwerkverbindung'
    },
    cover_info: {
        t01: 'Mit dem Verdienen beginnen',
        t02: 'Münzen aufladen',
        t03: 'Münzen abheben',
        t04: 'Zertifikate'
    },
    cont: {
        t01: 'Sprache auswählen',
        t02: 'Alle',
        t03: 'Ausstehend',
        t04: 'Abgeschlossen',
        t05: 'Gefroren',
        t06: 'Mein Guthaben',
        t07: 'Unvollständig',
        t08: 'Gesamtbestellungen',
        t09: 'Provision',
        t10: 'Erzielte Provision',
        t11: 'Anzahl der Bestellungen',
        t12: 'Verfügbares Guthaben',
        t13: 'Mit Bestellungen beginnen',
        t14: 'Kontoguthaben',
        t15: 'Bestellung aufgeben',
        t16: 'Alle Bestellungen aufgegeben',
        t17: 'Bestellzeit',
        t18: 'Bestellnummer',
        t19: 'Gesamtbetrag der Bestellung',
        t21: 'Werk',
        t22: 'Schauspieler',
        t23: 'Werkkommentare',
        t24: 'Abbrechen',
        t25: 'Bitte Bewertung auswählen',
        t26: 'Bestellung erfolgreich aufgegeben',
        t27: 'Erworbenes Bestellung',
        t28: 'Bestellung erfolgreich ergriffen',
        t29: 'Bestellung konnte nicht ergriffen werden, bitte versuchen Sie es später erneut!'
    },
    user: {
        t1: 'Empfehlungscode',
        t2: 'Guthaben',
        t3: 'Verfügbares Guthaben',
        t4: 'Gesamterwerb',
        t5: 'Abheben',
        t6: 'Einzahlungshistorie',
        t7: 'Abhebungshistorie',
        t8: 'Kontodetails',
        t9: 'Nachricht',
        t10: 'Bankkarte verbinden',
        t11: 'Passwort ändern',
        t12: 'Abhebungspasswort ändern',
        t13: 'Freunde einladen',
        t14: 'Sprache auswählen',
        t15: 'Abmelden',
        t16: 'Abheben',
        t17: 'Betrag zum Abheben',
        t18: 'Kontoinhaber',
        t19: 'Telefonnummer',
        t20: 'Betrag zum Abheben',
        t21: 'Abheben',
        t22: 'Geben Sie den Betrag zum Abheben ein',
        t23: 'Geben Sie Ihr virtuelles Guthabenpasswort ein',
        t24: 'Gesamteinzahlung',
        t25: 'Systemnachrichten',
        t26: 'Bankkarten Details',
        t27: 'Bankenliste',
        t28: 'Bankname',
        t29: 'Alias',
        t30: 'Bankkartennummer',
        t31: 'Telefonnummer',
        t32: 'Änderungen bestätigen',
        t33: 'Geben Sie Ihre verbundene Bankkartennummer und den IFSC-Code ein. Stellen Sie sicher, dass Sie Ihren Namen und Ihre Telefonnummer korrekt eingeben, da der eingezahlte Betrag nicht erhalten wird, wenn dies nicht geschieht.',
        t34: 'Vorheriges Passwort',
        t35: 'Neues Passwort',
        t36: 'Passwort bestätigen',
        t37: 'Weiter',
        t38: 'Merken Sie sich Ihr Passwort. Wenn Sie Ihr Passwort vergessen haben, wenden Sie sich bitte an den Kundenservice.',
        t39: 'Einladungslink kopieren',
        t40: 'Freunde einladen, um weitere Vorteile zu erhalten',
        t41: 'Einzahlen',
        t42: 'Bestätigen',
        t43: 'Abbrechen',
        t44: 'Sind Sie sicher, dass Sie sich abmelden möchten?',
        t45: 'Einzahlungsbetrag',
        t46: 'Die Einzahlung war erfolgreich',
        t47: 'Überprüfung abgeschlossen',
        t48: 'Überprüfung ausstehend',
        t49: 'Gesamtabhebung',
        t50: 'Bitte legen Sie zuerst Ihr Abhebungspasswort fest',
        t51: 'Geben Sie Ihr vorheriges Passwort ein',
        t52: 'Geben Sie Ihr neues Passwort ein',
        t53: 'Passwort bestätigen',
        t54: 'Die eingegebenen Passwörter stimmen nicht überein',
        t55: 'Kopiert',
        t56: 'Der Abhebetrag darf nicht weniger als 30 sein',
        t57: 'Erfolgreich gesendet, wird umgeleitet',
        t58: 'Überprüfung fehlgeschlagen',
        t59: 'Profilbild festlegen',
        t60: 'Jetzt festlegen',
        t61: 'Einstellung erfolgreich',
        t62: 'Nach der Wallet-Bestätigung müssen Sie sich anmelden, um Geld abzuheben',
        t63: 'Abhebung auf Bankkarte',
        t64: 'Abhebung auf USDT (Verhältnis 1:0,013)',
        t65: 'Bankkontonummer',
        t66: 'Geben Sie bitte die Bankkontonummer und den IFSC-Code der Bankkarte ein, die Sie verbinden möchten, sowie Ihren vollständigen Namen und Ihre Mobiltelefonnummer. Stellen Sie sicher, dass alle Informationen korrekt sind, um eine reibungslose Zahlung zu gewährleisten.',
        t67: 'Bitte binden Sie zuerst Ihre Bankkarte',
        t68: 'Benutzeraufladung',
        t69: 'Benutzer akzeptiert Bestellungen',
        t70: 'Untergeordnete Provision',
        t71: 'Benutzerabhebung',
        t72: 'In Yebao übertragen',
        t73: 'Aus Yebao übertragen',
        t74: 'Yebao-Erwerb',
        t75: 'Bestellprovision',
        t76: 'Das Guthaben ist unter 30, es kann nicht weiter gehandelt werden, bitte wenden Sie sich an den Kundenservice',
        t77: 'Bitte geben Sie den Banknamen ein',
        t78: 'Bitte geben Sie die Bankkontonummer ein',
        t80: 'Bitte geben Sie Ihren vollständigen Namen ein',
        t81: 'Bitte geben Sie Ihre Telefonnummer ein',
        t82: 'Bitte geben Sie den Abhebebetrag ein',
        t83: 'Kopieren',
        t84: 'Tägliche Top 100: Global',
        t85: 'Hören',
        t86: 'E-Mail',
        t87: 'Bitte geben Sie Ihre E-Mail ein',
        t88: 'Bankleitzahl',
        t89: 'Bitte geben Sie die Bankleitzahl ein',
        t90: 'Banküberweisung',
        t91: '1. Für Auszahlungen werden keine Gebühren erhoben',
        t92: '2. Die Auszahlung wird innerhalb von 10 bis 15 Minuten nach der Auszahlung erfolgreich gutgeschrieben. Bei Auszahlungen außerhalb der Geschäftszeiten erfolgt die Gutschrift zu den nächsten Geschäftszeiten.'
    },
    movie: {
        t01: 'Beliebte Filme und TV-Sendungen',
        t02: 'Zahlungspasswort',
        t03: 'Bestelldifferenz',
        t04: 'Verwaltung von On-Chain-Adressen',
        t05: 'Bitte eingeben',
        t06: 'Bitte geben Sie die korrekte On-Chain-Adresse und das entsprechende Netzwerk (z. B. ERC20/TRC20/BTC) ein, andernfalls können Auszahlungen/Überweisungen möglicherweise nicht ankommen oder zum Verlust von Vermögenswerten führen.',
        t07: 'Auf eine On-Chain-Adresse auszahlen',
        t08: 'Bitte hinzufügen',
        t09: 'Bitte fügen Sie eine On-Chain-Adresse hinzu',
    },
    langType: '德语'
}
